export default "__VITE_ASSET__ea34945b__"